import { uid } from "@dhx/ts-common/core";
import { sv } from "@dhx/ts-common/dom";
import { getCoordinates, pieLikeHandlers } from "../helpers/circle";
import { getRadialGradient, verticalCenteredText } from "../helpers/common";
import { SvgElement, NoScaleSubType } from "../types";
import NoScaleSeria from "./NoScaleSeria";

export default class Pie extends NoScaleSeria { // todo move to NoScaleSeria
	paint(width: number, height: number): SvgElement {
		const { stroke, strokeWidth, gradient, useLines, showText, showTextTemplate, subType } = this.config;
		const radius = height / 2;
		let currentPercent = -.25; // 0 percent is (1, 0) point, -.25 is (0, -1) point

		const tooltipData = [];

		let svg = [];

		const defs = [];
		const links = [];
		const pie = [];
		const lines = [];
		const err = this._points.length === 1 ? -.000001 : 0; // if move to start point it will be empty circle

		this._points.forEach(item => {
			const [percent, value, id, text, color] = item;
			let fill: any = color;
			if (gradient) {
				const grad = gradient(color as any);
				const gradientId = "gradient" + uid();
				const radialGradient = getRadialGradient(grad.options, grad.stops, gradientId);
				fill = `url(#${gradientId})`;
				defs.push(radialGradient);
			}
			const [startX, startY] = getCoordinates(currentPercent, radius, radius);
			const avPercent = currentPercent + percent / 2;
			const lineLength = avPercent < .25 ? 5 : -5; // from 0 to 180 right pointer, 180 to 360 left pointer
			const middleLine = getCoordinates(avPercent, radius, radius);
			const [startPart, endPart] = [5, 30];
			const [linkStart, linkEnd] = [getCoordinates(avPercent, radius + startPart, radius + startPart), getCoordinates(avPercent, radius + endPart, radius + endPart)];
			const className = avPercent > - 0.25 && avPercent < 0.25 ? "pie-value start-text" : "pie-value end-text";

			if (useLines) {
				links.push(sv("path", {d: `M${linkStart[0]} ${linkStart[1]} L${linkEnd[0]} ${linkEnd[1]} h ${lineLength}`, class: "pie-value-connector"}));
				const textSvg = sv("text", {x: linkEnd[0], y: linkEnd[1], dx: lineLength / 2 + lineLength > 0 ? 10 : -10, class: className}, [
					verticalCenteredText(text.toString())
				]);
				links.push(textSvg);
			} else {
				const textPadding = 5;
				const dy = avPercent > 0.5 || avPercent < 0 ? -textPadding : textPadding;
				const textSvg = sv("text", {x: linkStart[0], y: linkStart[1] + dy, class: className}, [
					verticalCenteredText(text.toString())
				]);
				links.push(textSvg);
			}
			if (showText || showTextTemplate) {
				const linkText = sv("text", {x: middleLine[0] * .7, y: middleLine[1] * .7, class: "pie-inner-value"}, [
					showTextTemplate ? verticalCenteredText(showTextTemplate(value.toString())) : verticalCenteredText(value.toString())
				]);
				links.push(linkText);
			}
			if (subType === NoScaleSubType.percentOnly) {
				const percentText = sv("text", {x: middleLine[0] * 0.5, y: middleLine[1] * 0.5, class: "pie-inner-value"}, [
					verticalCenteredText(Math.round(percent * 100) + "%")
				]);
				links.push(percentText);
			}
			currentPercent += percent + err;
			const [endX, endY] = getCoordinates(currentPercent, radius, radius);
			const largeArcFlag = percent > .5 ? 1 : 0;
			const d = `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY} L 0 0`;
			const [shiftX, shiftY] = getCoordinates(avPercent, 4, 4);

			const currentSector = sv("path", {
				d,
				class: "chart pie",
				_key: id,
				fill,
				onmouseover: [pieLikeHandlers.onmouseover, shiftX, shiftY],
				onmouseout: [pieLikeHandlers.onmouseout]
			});
			pie.push(currentSector);
			if (this._points.length > 1 && stroke) {
				const strokeOpts = {
					"stroke-width": strokeWidth,
					stroke
				};
				const line = sv("path", {d: `M0 0 L${endX} ${endY}`, fill: "none", ...strokeOpts});
				lines.push(line);
			}
			if (this._points.length === 1) {
				tooltipData.push([width / 2, height / 2]);
			} else {
				tooltipData.push([middleLine[0] * .7 + width / 2, middleLine[1] * .7 + height / 2]);
			}
		});

		this._center = [width / 2, height / 2];
		this._tooltipData = tooltipData;

		svg.push(sv("defs", defs));
		svg = svg.concat(pie);
		svg = svg.concat(lines);
		svg = svg.concat(links);
		return sv("g", { transform: `translate(${width / 2}, ${height / 2})` }, svg);
	}
}